import m from "./module";
import { LocationFilter } from "../model/LocationFilter";

class LocationFilterService {
  constructor($injector, $q, LogService) {
    "ngInject";
    this.$injector = $injector;
    this.$q = $q;
    this.LogService = LogService;
  }

  create(data) {
    data = data || {};
    let locationFilter = new LocationFilter(data);
    return locationFilter;
  }

  serialize(locationFilter) {
    let data = {
      id: locationFilter.id,
      type: locationFilter.type,
      subtype: locationFilter.subtype,
      value: locationFilter.value,
      value_description: locationFilter.valueDescription,
      parent_value: locationFilter.parentValue,
    };
    return data;
  }
}

export default LocationFilterService;

m.service("LocationFilterService", LocationFilterService);
